import { createContext } from "react";

export const UserContext = createContext({"photo": require('../assets/vnn_logo.png'), "email": "", "name": "", "title": ""});
